import { NEW_POPUP, REMOVE_POPUP } from './types'

export const addPopup = (text, severity = 'info') => dispatch => {
    dispatch({ type: NEW_POPUP, text, severity })
}

export const removePopup = index => dispatch => {
    dispatch({ type: REMOVE_POPUP, index })
}
